module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-3x2-547b62f72f592713c50e8cfbd5f70d5a.jpg";